module.exports = {"431221100":"中方镇","431221102":"泸阳镇","431221103":"花桥镇","431221104":"铜湾镇","431221105":"桐木镇","431221106":"铁坡镇","431221107":"新建镇","431221108":"接龙镇","431221109":"铜鼎镇","431221110":"新路河镇","431221111":"袁家镇","431221214":"蒿吉坪瑶族乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/431221.json
// module id = 1918
// module chunks = 0